module.exports = __webpack_public_path__ + "img/4_dp.9dfbd5c1.png";